import { render, staticRenderFns } from "./adaptiveModel.vue?vue&type=template&id=64601ef4&scoped=true&"
import script from "./adaptiveModel.vue?vue&type=script&lang=js&"
export * from "./adaptiveModel.vue?vue&type=script&lang=js&"
import style0 from "./adaptiveModel.vue?vue&type=style&index=0&id=64601ef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64601ef4",
  null
  
)

export default component.exports